import moment, { Moment } from 'moment-timezone';

import { PaymentDateOptionsDto } from '@alpha/payments-dtos';

const calculateDisablePaymentDates = (
  _date: Moment,
  dateOptions?: PaymentDateOptionsDto,
  corpayMigrationStartDate?: string,
): boolean => {
  if (dateOptions) {
    const defaultTimezone = moment.tz.guess();

    const formattedDate = _date.tz(defaultTimezone)
      .format('YYYY-MM-DD');
    const todayDate = moment.tz('Europe/London').format('YYYY-MM-DD');

    const notHolidays = dateOptions.holidays.some((holiday) => moment(holiday.date).tz('Europe/London').format('YYYY-MM-DD') === formattedDate);
    _date.tz(defaultTimezone);

    const migrationDate = corpayMigrationStartDate
      ? moment(corpayMigrationStartDate).format('YYYY-MM-DD')
      : undefined;

    const isAfterMigrationStart = migrationDate
      ? moment(formattedDate).isAfter(migrationDate)
        || (moment(formattedDate).isSame(migrationDate)
          && moment.tz('Europe/London').isAfter(moment.tz(corpayMigrationStartDate, 'Europe/London')))
      : false;

    return (
      moment(formattedDate).isBefore(todayDate)
      || moment(formattedDate).isBefore(dateOptions.earliestDate)
      || moment(formattedDate).isAfter(dateOptions.latestDate)
      || notHolidays
      || isAfterMigrationStart
    );
  }
  return false;
};

export default calculateDisablePaymentDates;
